// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader_preloader__1zu7m","rotation":"preloader_rotation__3oYGY","anim_rotation":"preloader_anim_rotation__1qQhv"};